import { Box } from "@mui/material";
import React from "react";

import "@splidejs/react-splide/css/skyblue";

import { PORTFOLIO_PROJECTS } from "../config/portfolioProjects";
import PortfolioCard from "../components/PortfolioCard";
import { usePageTitle } from "../hooks/usePageTitle";

function Portfolio(props) {
  usePageTitle("Our Work");
  
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box pt={{ xs: 11, sm: 12, md: 17, lg: 18, xl: 20 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: props.lessSM ? "column" : "row",
            justifyContent: props.lessSM ? "space-between" : "space-around",
            alignItems: "center",
            width: "100%",
            height: {
              xs: "180vw",
              sm: "30vw",
              md: "30vw",
              lg: "80vh",
              xl: "80vh",
            },
            my: { xs: 5, sm: 5, md: 5, lg: 5, xl: 5 },
            backgroundColor: "#050505",
          }}
        >
          {PORTFOLIO_PROJECTS.map((project, index) => (
            <PortfolioCard
              key={project.id}
              project={project}
              onOpen={props.onOpen}
              scrollToTopOnLoad={index === 0}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default Portfolio;
